import state from './moduleCustomerState'
import mutations from './moduleCustomerMutations'
import actions from './moduleCustomerActions'
import getters from './moduleCustomerGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

